/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Th_Your_EvidenceInputs */

const en_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const de_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const fr_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const es_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const it_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const nl_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const pl_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const fi_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const da_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

const sv_deep_match_th_your_evidence = /** @type {(inputs: Deep_Match_Th_Your_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Evidence`)
};

/**
* | output |
* | --- |
* | "Your Evidence" |
*
* @param {Deep_Match_Th_Your_EvidenceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_th_your_evidence = /** @type {((inputs?: Deep_Match_Th_Your_EvidenceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Th_Your_EvidenceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_th_your_evidence(inputs)
	if (locale === "fr") return fr_deep_match_th_your_evidence(inputs)
	if (locale === "es") return es_deep_match_th_your_evidence(inputs)
	if (locale === "it") return it_deep_match_th_your_evidence(inputs)
	if (locale === "nl") return nl_deep_match_th_your_evidence(inputs)
	if (locale === "pl") return pl_deep_match_th_your_evidence(inputs)
	if (locale === "fi") return fi_deep_match_th_your_evidence(inputs)
	if (locale === "da") return da_deep_match_th_your_evidence(inputs)
	if (locale === "sv") return sv_deep_match_th_your_evidence(inputs)
	return en_deep_match_th_your_evidence(inputs)
});